var map; 
var markers = [];

$(document).ready(function(){
  $('.cart-comment-toggle').click(function(){
    $(this).siblings('.cart-comment').toggle();
  });
  var mod_carts = false;
  
  var rates = {
      Sweden_h: 90,
      Sweden_w: 90,
      Sweden_no_shipping: 0,
      Denmark_p: 29,
      Denmark_h: 39,
      Denmark_w: 29,
      Denmark_l: 0,
      Denmark_no_shipping: 0,
      Norway_h: 210,
      Norway_w: 210,
      Norway_no_shipping: 0,
      Germany_h: 59,
      Germany_w: 59,
      Germany_no_shipping: 0,
      UK_h: 59,
      UK_w: 59,
      UK_no_shipping: 0
  };

  var danish = {
    DELIVER_TO_HOME_ADDRESS_3: "hjem-til-3",
    DELIVER_TO_WORK_ADDRESS_2: "arbejde-2",
    A_LOCAL_PAKKE_SHOP_1: "pakkeshop-1",
    COLLECT_IN_STORE_4: "afhent-hos-vest-by-vest-4"
  };

  var short_names_country = {
    DK: 'Denmark',
    NO: 'Norway',
    DE: 'Germany',
    SE: 'Sweden',
    GB: 'UK'
  };

  var denmark_city_zipcodes = {
    'Frederiksberg': 2000,
    'Copenhagen Ø': 2100,
    'Copenhagen N': 2200,
    'Copenhagen S': 2300,
    'Copenhagen NV': 2400,
    'Copenhagen SV': 2450,
    'Copenhagen': 2100,
    'Valby': 2500,
    'Glostrup': 2600,
    'Brøndby': 2605,
    'Rødovre': 2610,
    'Albertslund': 2620,
    'Vallensbæk': 2625,
    'Taastrup': 2630,
    'Ishøj': 2635,
    'Hedehusene': 2640,
    'Hvidovre': 2650,
    'Brøndby Strand': 2660,
    'Vallensbæk Strand': 2665,
    'Greve': 2670,
    'Solrød Strand': 2680,
    'Karlslunde': 2690,
    'Brønshøj': 2700,
    'Vanløse': 2720,
    'Herlev': 2730,
    'Skovlunde': 2740,
    'Ballerup': 2750,
    'Måløv': 2760,
    'Smørum': 2765,
    'Kastrup': 2770,
    'Dragør': 2791,
    'Kongens Lyngby': 2800,
    'Gentofte': 2820,
    'Virum': 2830,
    'Holte': 2840,
    'Nærum': 2850,
    'Søborg': 2860,
    'Dyssegård': 2870,
    'Bagsværd': 2880,
    'Hellerup': 2900,
    'Charlottenlund': 2920,
    'Klampenborg': 2930,
    'Skodsborg': 2942,
    'Vedbæk': 2950,
    'Rungsted Kyst': 2960,
    'Hørsholm': 2970,
    'Kokkedal': 2980,
    'Nivå': 2990,
    'Helsingør': 3000,
    'Humlebæk': 3050,
    'Espergærde': 3060,
    'Snekkersten': 3070,
    'Tikøb': 3080,
    'Hornbæk': 3100,
    'Dronningmølle': 3120,
    'Ålsgårde': 3140,
    'Hellebæk': 3150,
    'Helsinge': 3200,
    'Vejby': 3210,
    'Tisvildeleje': 3220,
    'Græsted': 3230,
    'Gilleleje': 3250,
    'Frederiksværk': 3300,
    'Ølsted': 3310,
    'Skævinge': 3320,
    'Gørløse': 3330,
    'Liseleje': 3360,
    'Melby': 3370,
    'Hundested': 3390,
    'Hillerød': 3400,
    'Lillerød': 3450,
    'Birkerød': 3460,
    'Fredensborg': 3480,
    'Kvistgård': 3490,
    'Værløse': 3500,
    'Farum': 3520,
    'Lynge': 3540,
    'Slangerup': 3550,
    'Frederikssund': 3600,
    'Jægerspris': 3630,
    'Ølstykke': 3650,
    'Stenløse': 3660,
    'Veksø Sjælland': 3670,
    'Roskilde': 4000,
    'Tune': 4030,
    'Jyllinge': 4040,
    'Skibby': 4050,
    'Kirke Såby': 4060,
    'Kirke Hyllinge': 4070,
    'Ringsted': 4100,
    'Viby Sjælland': 4130,
    'Borup': 4140,
    'Herlufmagle': 4160,
    'Glumsø': 4171,
    'Fjenneslev': 4173,
    'Jystrup Midtsjælland': 4174,
    'Sorø': 4180,
    'Munke Bjergby': 4190,
    'Slagelse': 4200,
    'Korsør': 4220,
    'Skælskør': 4230,
    'Vemmelev': 4241,
    'Boeslunde': 4242,
    'Rude': 4243,
    'Fuglebjerg': 4250,
    'Dalmose': 4261,
    'Sandved': 4262,
    'Høng': 4270,
    'Gørlev': 4281,
    'Ruds Vedby': 4291,
    'Dianalund': 4293,
    'Stenlille': 4295,
    'Nyrup': 4296,
    'Holbæk': 4300,
    'Lejre': 4320,
    'Hvalsø': 4330,
    'Tølløse': 4340,
    'Ugerløse': 4350,
    'Kirke Eskilstrup': 4360,
    'Store Merløse': 4370,
    'Vipperød': 4390,
    'Kalundborg': 4400,
    'Regstrup': 4420,
    'Mørkøv': 4440,
    'Jyderup': 4450,
    'Snertinge': 4460,
    'Svebølle': 4470,
    'Store Fuglede': 4480,
    'Jerslev Sjælland': 4490,
    'Nykøbing Sjælland': 4500,
    'Svinninge': 4520,
    'Gislinge': 4532,
    'Hørve': 4534,
    'Fårevejle': 4540,
    'Asnæs': 4550,
    'Vig': 4560,
    'Grevinge': 4571,
    'Nørre Asmindrup': 4572,
    'Højby': 4573,
    'Rørvig': 4581,
    'Sjællands Odde': 4583,
    'Føllenslev': 4591,
    'Sejerø': 4592,
    'Eskebjerg': 4593,
    'Køge': 4600,
    'Gadstrup': 4621,
    'Havdrup': 4622,
    'Lille Skensved': 4623,
    'Bjæverskov': 4632,
    'Faxe': 4640,
    'Hårlev': 4652,
    'Karise': 4653,
    'Faxe Ladeplads': 4654,
    'Store Heddinge': 4660,
    'Strøby': 4671,
    'Klippinge': 4672,
    'Rødvig Stevns': 4673,
    'Herfølge': 4681,
    'Tureby': 4682,
    'Rønnede': 4683,
    'Holmegaard': 4684,
    'Haslev': 4690,
    'Næstved': 4700,
    'Præstø': 4720,
    'Tappernøje': 4733,
    'Mern': 4735,
    'Karrebæksminde': 4736,
    'Lundby': 4750,
    'Vordingborg': 4760,
    'Kalvehave': 4771,
    'Langebæk': 4772,
    'Stensved': 4773,
    'Stege': 4780,
    'Borre': 4791,
    'Askeby': 4792,
    'Bogø By': 4793,
    'Nykøbing Falster': 4800,
    'Nørre Alslev': 4840,
    'Stubbekøbing': 4850,
    'Guldborg': 4862,
    'Eskilstrup': 4863,
    'Horbelev': 4871,
    'Idestrup': 4872,
    'Væggerløse': 4873,
    'Gedser': 4874,
    'Nysted': 4880,
    'Toreby Lolland': 4891,
    'Kettinge': 4892,
    'Øster Ulslev': 4894,
    'Errindlev': 4895,
    'Nakskov': 4900,
    'Harpelunde': 4912,
    'Horslunde': 4913,
    'Søllested': 4920,
    'Maribo': 4930,
    'Bandholm': 4941,
    'Torrig Lolland': 4943,
    'Fejø': 4944,
    'Nørreballe': 4951,
    'Stokkemarke': 4952,
    'Vesterborg': 4953,
    'Holeby': 4960,
    'Rødby': 4970,
    'Dannemare': 4983,
    'Sakskøbing': 4990,
    'Rønne': 3700,
    'Aakirkeby': 3720,
    'Nexø': 3730,
    'Svaneke': 3740,
    'Østermarie': 3751,
    'Gudhjem': 3760,
    'Allinge': 3770,
    'Klemensker': 3782,
    'Hasle': 3790,
    'Odense C': 5000,
    'Odense V': 5200,
    'Odense NV': 5210,
    'Odense SØ': 5220,
    'Odense M': 5230,
    'Odense NØ': 5240,
    'Odense SV': 5250,
    'Odense S': 5260,
    'Odense N': 5270,
    'Marslev': 5290,
    'Kerteminde': 5300,
    'Agedrup': 5320,
    'Munkebo': 5330,
    'Rynkeby': 5350,
    'Mesinge': 5370,
    'Dalby': 5380,
    'Martofte': 5390,
    'Bogense': 5400,
    'Otterup': 5450,
    'Morud': 5462,
    'Harndrup': 5463,
    'Brenderup Fyn': 5464,
    'Asperup': 5466,
    'Søndersø': 5471,
    'Veflinge': 5474,
    'Skamby': 5485,
    'Blommenslyst': 5491,
    'Vissenbjerg': 5492,
    'Middelfart': 5500,
    'Ullerslev': 5540,
    'Langeskov': 5550,
    'Aarup': 5560,
    'Nørre Aaby': 5580,
    'Gelsted': 5591,
    'Ejby': 5592,
    'Faaborg': 5600,
    'Assens': 5610,
    'Glamsbjerg': 5620,
    'Ebberup': 5631,
    'Millinge': 5642,
    'Broby': 5672,
    'Haarby': 5683,
    'Tommerup': 5690,
    'Svendborg': 5700,
    'Ringe': 5750,
    'Vester Skerninge': 5762,
    'Stenstrup': 5771,
    'Kværndrup': 5772,
    'Årslev': 5792,
    'Nyborg': 5800,
    'Ørbæk': 5853,
    'Gislev': 5854,
    'Ryslinge': 5856,
    'Ferritslev Fyn': 5863,
    'Frørup': 5871,
    'Hesselager': 5874,
    'Skårup Fyn': 5881,
    'Vejstrup': 5882,
    'Oure': 5883,
    'Gudme': 5884,
    'Gudbjerg Sydfyn': 5892,
    'Rudkøbing': 5900,
    'Humble': 5932,
    'Bagenkop': 5935,
    'Tranekær': 5953,
    'Marstal': 5960,
    'Ærøskøbing': 5970,
    'Søby Ærø': 5985,
    'Kolding': 6000,
    'Egtved': 6040,
    'Almind': 6051,
    'Viuf': 6052,
    'Jordrup': 6064,
    'Christiansfeld': 6070,
    'Bjert': 6091,
    'Sønder Stenderup': 6092,
    'Sjølund': 6093,
    'Hejls': 6094,
    'Haderslev': 6100,
    'Aabenraa': 6200,
    'Rødekro': 6230,
    'Løgumkloster': 6240,
    'Bredebro': 6261,
    'Tønder': 6270,
    'Højer': 6280,
    'Gråsten': 6300,
    'Broager': 6310,
    'Egernsund': 6320,
    'Padborg': 6330,
    'Kruså': 6340,
    'Tinglev': 6360,
    'Bylderup-Bov': 6372,
    'Bolderslev': 6392,
    'Sønderborg': 6400,
    'Nordborg': 6430,
    'Augustenborg': 6440,
    'Sydals': 6470,
    'Vojens': 6500,
    'Gram': 6510,
    'Toftlund': 6520,
    'Agerskov': 6534,
    'Branderup Jylland': 6535,
    'Bevtoft': 6541,
    'Sommersted': 6560,
    'Vamdrup': 6580,
    'Vejen': 6600,
    'Gesten': 6621,
    'Bække': 6622,
    'Vorbasse': 6623,
    'Rødding': 6630,
    'Lunderskov': 6640,
    'Brørup': 6650,
    'Lintrup': 6660,
    'Holsted': 6670,
    'Hovborg': 6682,
    'Føvling': 6683,
    'Gørding': 6690,
    'Esbjerg': 6700,
    'Esbjerg Ø': 6705,
    'Esbjerg V': 6710,
    'Esbjerg N': 6715,
    'Fanø': 6720,
    'Tjæreborg': 6731,
    'Bramming': 6740,
    'Glejbjerg': 6752,
    'Agerbæk': 6753,
    'Ribe': 6760,
    'Gredstedbro': 6771,
    'Skærbæk': 6780,
    'Rømø': 6792,
    'Varde': 6800,
    'Årre': 6818,
    'Ansager': 6823,
    'Nørre Nebel': 6830,
    'Oksbøl': 6840,
    'Janderup Vestjylland': 6851,
    'Billum': 6852,
    'Vejers Strand': 6853,
    'Henne': 6854,
    'Outrup': 6855,
    'Blåvand': 6857,
    'Tistrup': 6862,
    'Ølgod': 6870,
    'Tarm': 6880,
    'Hemmet': 6893,
    'Skjern': 6900,
    'Videbæk': 6920,
    'Kibæk': 6933,
    'Lem St.': 6940,
    'Ringkøbing': 6950,
    'Hvide Sande': 6960,
    'Spjald': 6971,
    'Ørnhøj': 6973,
    'Tim': 6980,
    'Ulfborg': 6990,
    'Fredericia': 7000,
    'Børkop': 7080,
    'Vejle': 7100,
    'Vejle Øst': 7120,
    'Juelsminde': 7130,
    'Stouby': 7140,
    'Barrit': 7150,
    'Tørring': 7160,
    'Uldum': 7171,
    'Vonge': 7173,
    'Bredsten': 7182,
    'Randbøl': 7183,
    'Vandel': 7184,
    'Billund': 7190,
    'Grindsted': 7200,
    'Hejnsvig': 7250,
    'Sønder Omme': 7260,
    'Stakroge': 7270,
    'Sønder Felding': 7280,
    'Jelling': 7300,
    'Gadbjerg': 7321,
    'Give': 7323,
    'Brande': 7330,
    'Ejstrupholm': 7361,
    'Hampen': 7362,
    'Herning': 7400,
    'Ikast': 7430,
    'Bording': 7441,
    'Engesvang': 7442,
    'Sunds': 7451,
    'Karup Jylland': 7470,
    'Vildbjerg': 7480,
    'Aulum': 7490,
    'Holstebro': 7500,
    'Haderup': 7540,
    'Sørvad': 7550,
    'Hjerm': 7560,
    'Vemb': 7570,
    'Struer': 7600,
    'Lemvig': 7620,
    'Bøvlingbjerg': 7650,
    'Bækmarksbro': 7660,
    'Harboøre': 7673,
    'Thyborøn': 7680,
    'Thisted': 7700,
    'Hanstholm': 7730,
    'Frøstrup': 7741,
    'Vesløs': 7742,
    'Snedsted': 7752,
    'Bedsted Thy': 7755,
    'Hurup Thy': 7760,
    'Vestervig': 7770,
    'Thyholm': 7790,
    'Skive': 7800,
    'Vinderup': 7830,
    'Højslev': 7840,
    'Stoholm Jylland': 7850,
    'Spøttrup': 7860,
    'Roslev': 7870,
    'Fur': 7884,
    'Nykøbing Mors': 7900,
    'Erslev': 7950,
    'Karby': 7960,
    'Redsted Mors': 7970,
    'Vils': 7980,
    'Øster Assels': 7990,
    'Århus C': 8000,
    'Århus N': 8200,
    'Århus V': 8210,
    'Brabrand': 8220,
    'Åbyhøj': 8230,
    'Risskov': 8240,
    'Egå': 8250,
    'Viby Jylland': 8260,
    'Højbjerg': 8270,
    'Odder': 8300,
    'Samsø': 8305,
    'Tranbjerg Jylland': 8310,
    'Mårslet': 8320,
    'Beder': 8330,
    'Malling': 8340,
    'Hundslund': 8350,
    'Solbjerg': 8355,
    'Hasselager': 8361,
    'Hørning': 8362,
    'Hadsten': 8370,
    'Trige': 8380,
    'Tilst': 8381,
    'Hinnerup': 8382,
    'Ebeltoft': 8400,
    'Rønde': 8410,
    'Knebel': 8420,
    'Balle': 8444,
    'Hammel': 8450,
    'Harlev Jylland': 8462,
    'Galten': 8464,
    'Sabro': 8471,
    'Sporup': 8472,
    'Grenaa': 8500,
    'Lystrup': 8520,
    'Hjortshøj': 8530,
    'Skødstrup': 8541,
    'Hornslet': 8543,
    'Mørke': 8544,
    'Ryomgård': 8550,
    'Kolind': 8560,
    'Trustrup': 8570,
    'Nimtofte': 8581,
    'Glesborg': 8585,
    'Ørum Djurs': 8586,
    'Anholt': 8592,
    'Silkeborg': 8600,
    'Kjellerup': 8620,
    'Lemming': 8632,
    'Sorring': 8641,
    'Ans By': 8643,
    'Them': 8653,
    'Bryrup': 8654,
    'Skanderborg': 8660,
    'Låsby': 8670,
    'Ry': 8680,
    'Horsens': 8700,
    'Daugård': 8721,
    'Hedensted': 8722,
    'Løsning': 8723,
    'Hovedgård': 8732,
    'Brædstrup': 8740,
    'Gedved': 8751,
    'Østbirk': 8752,
    'Flemming': 8762,
    'Rask Mølle': 8763,
    'Klovborg': 8765,
    'Nørre Snede': 8766,
    'Stenderup': 8781,
    'Hornsyld': 8783,
    'Viborg': 8800,
    'Tjele': 8830,
    'Løgstrup': 8831,
    'Skals': 8832,
    'Rødkærsbro': 8840,
    'Bjerringbro': 8850,
    'Ulstrup': 8860,
    'Langå': 8870,
    'Thorsø': 8881,
    'Fårvang': 8882,
    'Gjern': 8883,
    'Randers C': 8900,
    'Randers NV': 8920,
    'Randers NØ': 8930,
    'Randers SV': 8940,
    'Randers SØ': 8960,
    'Ørsted': 8950,
    'Allingåbro': 8961,
    'Auning': 8963,
    'Havndal': 8970,
    'Spentrup': 8981,
    'Gjerlev Jylland': 8983,
    'Fårup': 8990,
    'Aalborg': 9000,
    'Aalborg SV': 9200,
    'Aalborg SØ': 9210,
    'Aalborg Øst': 9220,
    'Svenstrup Jylland': 9230,
    'Nibe': 9240,
    'Gistrup': 9260,
    'Klarup': 9270,
    'Storvorde': 9280,
    'Kongerslev': 9293,
    'Sæby': 9300,
    'Vodskov': 9310,
    'Hjallerup': 9320,
    'Dronninglund': 9330,
    'Asaa': 9340,
    'Dybvad': 9352,
    'Gandrup': 9362,
    'Hals': 9370,
    'Vestbjerg': 9380,
    'Sulsted': 9381,
    'Tylstrup': 9382,
    'Nørresundby': 9400,
    'Vadum': 9430,
    'Aabybro': 9440,
    'Brovst': 9460,
    'Løkken-Vrå': 9480,
    'Pandrup': 9490,
    'Blokhus': 9492,
    'Saltum': 9493,
    'Hobro': 9500,
    'Arden': 9510,
    'Skørping': 9520,
    'Støvring': 9530,
    'Suldrup': 9541,
    'Mariager': 9550,
    'Hadsund': 9560,
    'Bælum': 9574,
    'Terndrup': 9575,
    'Aars': 9600,
    'Nørager': 9610,
    'Aalestrup': 9620,
    'Gedsted': 9631,
    'Møldrup': 9632,
    'Farsø': 9640,
    'Løgstør': 9670,
    'Ranum': 9681,
    'Fjerritslev': 9690,
    'Brønderslev': 9700,
    'Jerslev Jylland': 9740,
    'Østervrå': 9750,
    'Vrå': 9760,
    'Hjørring': 9800,
    'Tårs': 9830,
    'Hirtshals': 9850,
    'Sindal': 9870,
    'Bindslev': 9881,
    'Frederikshavn': 9900,
    'Læsø': 9940,
    'Strandby': 9970,
    'Jerup': 9981,
    'Ålbæk': 9982

  };
  function display_g_map(){
    document.getElementById('map-canvas').style.display="block";
    initialize();
    g_call_country();
    
    $('#g_zip_action').click(function(){
      g_call_country($('#g_zip_search').val());
    });
  }
  
  function initialize() {
    var mapOptions = {
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      center: new google.maps.LatLng(55.6789, 12.5335),
    };
    
    map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
    google.maps.event.addDomListener(window, 'load', initialize);
    google.maps.event.trigger(map, 'resize');
  
  }
  
  function g_create_markers(json){
    var array_data = [];
    var zoomI = false;
    
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
    
    g_map_clearList();
    
    for (var i =0; i < json.length; i++){
      array_data[i] = json[i];
      
    }
    
    if (markers) {
      infowindow = [];
      
      for (var i in array_data) {
        var details = array_data[i];
      	console.log(details);
        
        infowindow[i] = new google.maps.InfoWindow({
          content: "<div>"+
          "<b>"+ details.company_name +"</b><br/>"+
          details.streetname +"<br/>"+
          "</div>",
        });

        
        if (zoomI == false){
          zoomI = true;
          map.panTo(new google.maps.LatLng(details.latitude, details.longitude));
        }
        
        g_map_addToList(details);
        
        markers[i] = new google.maps.Marker({
          title: details.company_name,
          position: new google.maps.LatLng(
            details.latitude, details.longitude),
          clickable: true,
          draggable: false,
          flat: true,
          map: map,
          icon: "//test-vestbyvest.myshopify.com/cdn/shop/t/2/assets/GLS_icon_40.png?v=152885365680822384481414016861",
          id: i,
          //icon: details.image
        });
        
        
        google.maps.event.addListener(markers[i], 'mouseover', function() {
            infowindow[this.id].open(map, this);

        });
        
        // assuming you also want to hide the infowindow when user mouses-out
        google.maps.event.addListener(markers[i], 'mouseout', function() {
            infowindow[this.id].close();
        });
      }
    }
    
    //var mc = new MarkerClusterer(map, markers);
  }
  
  function g_call_country(search){
    //If no zip has been provided
    if (search == null){
      $.getJSON( "http://freegeoip.net/json/", function(data){
        map.panTo(new google.maps.LatLng(data['latitude'], data['longitude']));
        var zip = data['zipcode'];
        $('#g_zip_search').attr('value', zip);
        
          $.ajax({
           url:"http://morfars-metafields.herokuapp.com/pakke_in_zip/" +zip,
           dataType: 'json', // Notice! JSONP <-- P (lowercase)
           success:function(json){
             g_create_markers(json);
           },
           error:function( jqXHR,  textStatus,  errorThrown){
             //alert('Error: There was a problem fetching map marker data. Please switch to a modern browser and whitelist http://morfars-metafields.herokuapp.com in any script blockers you have installed.');
           },
          });
      });
    }else{
      /*
      geocoder = new google.maps.Geocoder();
  
      geocoder.geocode({ address: search}, function(results, status) {
      map.panTo(results[0].geometry.location);
  
          if (status == google.maps.GeocoderStatus.OK) {
            console.log(results);
          }
      });
      */
      
      $.ajax({
        url:"http://morfars-metafields.herokuapp.com/pakke_in_zip/" +search,
        dataType: 'json', // Notice! JSONP <-- P (lowercase)
        
        success:function(json){
          g_create_markers(json);
          
          // after adding to the list of pakkeshop, we need
          // to adjust some margins so that the list is not
          // overlapping the footer, etc...
          // previously this was done in setTimeouts, but doing
          // in this callback is more reliable
          var window_cart_m = $(window).width();
          if ((window_cart_m >= 750)) { 
            var map_height = $('.pakke-shipping-block').height();
            $('#footer').css( "margin-top", map_height + 50)   
          }else{
            var map_height = $('.pakke-shipping-block').height();
            $('#checkout-controls-container').css( "margin-top", map_height + 50)   
          }
        },
        error:function( jqXHR,  textStatus,  errorThrown){
          //alert('Error: There was a problem fetching map marker data. Please switch to a modern browser and whitelist http://morfars-metafields.herokuapp.com in any script blockers you have installed.');
        },
      });
    }
  }
  
  function g_map_addToList(marker){
    console.log(marker);
    
    var oldhtml = $('#g_list').html();
    
    var html = "<label class = 'g_list_box'>"+
        "<input type='radio' id='"+marker.number+"' name='g_shop_selection' value='"+marker.number+"' />"+
        "<div class = 'g_list_company_name'>"+ marker.company_name +"</div>"+
        "<div class = 'g_list_city'>"+ marker.city_name +"</div>"+
        "<div class = 'g_list_street'>"+ marker.streetname +"</div>"+
        "<div class = 'g_list_street2'>"+ marker.streetname2 +"</div>"+
        "<div class = 'g_list_zip'>"+ marker.zip_code +"</div>"+
    "</label>";
    
    $('#g_list').html(oldhtml + html);  	
  }  
  
  function g_map_clearList(){
      $('#g_list').html('');
  }

  $('#basket-right #checkout').removeAttr('disabled');
  
  $("#g_list input[name='g_shop_selection']").live('change', function(e){
    
      var class_name = $(this).attr('id');
    
      var pakke_shop_parts = $(this).children('option:selected').text().split(" ");
      var pakke_shop_number = pakke_shop_parts.shift();
      var pakke_shop_name = $(this).siblings('.g_list_company_name').html();
      var pakke_shop_id = $(this).val();
      $('.pakke_shop_name_label').attr('value', pakke_shop_name);
  
      $('#pakke_shop_id').attr('value', pakke_shop_id);
  
      $('#pakke_shop_address').attr('value', $(this).siblings('.g_list_street').text());
      $('#pakke_shop_city').attr('value', $(this).siblings('.g_list_city').text());
      $('#pakke_shop_zip_code').attr('value', $(this).siblings('.g_list_zip').text());
  });


  var shipping_prod_id = $('.shipping_prod_variant_id').text();
  var ip = '';
  $('#cartform #basket-right #checkout').addClass("disabled");

  var shipping_product_id;
  jQuery.getJSON('/products/shipping.js', function (product, textStatus) {
    shipping_product_id = product['variants'][0]['id']
  });

  Shopify.removeItem(shipping_prod_id);

  call_ajax_set_country();

  $('select#country').change(function(){

    sentinel.shipping = ""; // force shipping method check at checkout time
    sentinel.shipping_selected = "";

    var country_code_selected = $(this).children('option:selected').val();

    if(($(this).children('option:selected').val() == '')||(country_code_selected == 'DK')){
      $('.dk-only').show();
    }else{
      $('.dk-only').hide();

    }

    if (country_code_selected == 'NO') {
      $('.no-only').show();
    }
    else {
      $('.no-only').hide();
    }

    var country_selected = $(this).children('option:selected').text();
    if ((!country_selected)||(country_selected == '')||(country_selected == 'Denmark')){
      var c_p = 'Denmark_p';
      var c_w = 'Denmark_w';
      var c_h = 'Denmark_h';
      var c_o = 'Denmark_o';

      if (rates[c_p] == 0){

        $('#' + danish["A_LOCAL_PAKKE_SHOP_1"] + ' .shipping-option .shipping-price').html('(' + "00,00" + ')');
      }
      else{
        //$('#afhent-i-pakkeshop-1 .shipping-rates').text('Flat rate of '+rates[c_p]+'.00');
        $('#' + danish["A_LOCAL_PAKKE_SHOP_1"] + ' .shipping-option .shipping-price').html('(' + rates[c_p] + '.00' + ')');
      }

      $('#' + danish["DELIVER_TO_HOME_ADDRESS_3"] + ' .shipping-option .shipping-price').html('(' + rates[c_h] + '.00' + ')');
      $('#' + danish["DELIVER_TO_WORK_ADDRESS_2"] + ' .shipping-option .shipping-price').html('(' + rates[c_w] + '.00' + ')');
      $('#' + danish["COLLECT_IN_STORE_4"] + ' .shipping-option .shipping-price').html('(' + '00.00' + ')');

    }
    else{

      var c_w = country_selected+'_w';
      var c_h = country_selected+'_h';

      $('.shipping-option .shipping-price').html('(' + rates[c_h] + '.00' + ')');
    }

    $('.shipping-category-block input:radio').each(function(){
      $(this).attr('checked', false);
    });

    $('.shipping-category-block .shipping-rates-div .tick img').hide();
    $('.shipping-category-block .sub-div').hide();
    $('#basket-right #checkout').addClass('disabled');

    Shopify.removeItem(shipping_prod_id);

    check_if_shipping_needed();

  });

  $('select#country').trigger('change');

  /* Show Sub Divs on page load */
  $('.sub-div').hide();
  $('input:radio', '.shipping-category-block').each(function(){
    if($(this).attr('checked') == "checked"){
      $('.sub-div', $(this).parent()).show();
    }
  });

  /* Show Sub Div on click */
  $('input:radio').click(function(){
    $('.sub-div').hide();
    $('.sub-div', $(this).parent()).show();
  });



  $('#terms-of-service').click(function() {
    $('.checkout-controls .tooltip-filter').hide();
  });

  $('.shipping-category-block div.shipping-rates-div').click(function(){
         
    $('.shipping-category .tooltip-filter').hide();

    $('.shipping-category-block input:radio').each(function(){
      $(this).attr('checked', false);
    });
    $(this).prev().attr('checked', true);

    var option_selected = $(this).attr('id');
    $('.sub-div').hide();
    $('.sub-div', $(this).parent()).show();
    $('.tick img').hide();
    $('.shipping-rates .tick img', $(this)).show();
    
    var window_cart = $(window).width();
    var width = $(this).parent().parent('.shipping-category').outerWidth();
    var height = $('.sub-div', $(this).parent()).outerHeight();
    if ((window_cart >= 1220)) { 
      $('.sub-div', $(this).parent()).css({
        width: "70%"
      });
      $('#footer').css( "margin-top", height + 10);
    } else if ((window_cart >= 750)) { 
      $('.sub-div', $(this).parent()).css({
        width: "420px"
      });
      $('#footer').css( "margin-top", height + 10)
    }else{
      console.log("doing this");
      $('.sub-div', $(this).parent()).css({
        top: "190px"
      });
      $('#checkout-controls-container').css( "margin-top", height + 50)      
    }  
    
    clear_all_options();
    var option_name = '';
    var suffix = '';

    switch (option_selected) {
      case 'pakkeshop-1':
        option_name = 'Pakkeshop';
        suffix = '_p';
        display_g_map();
      break;
      case 'arbejde-2':
        set_work_address_to_match_country();
        option_name = 'Arbejde';
        suffix = '_w';
      break;
      case 'hjem-til-3':
        option_name = 'Hjem til';
        suffix = '_h';
      break;
      case 'afhent-hos-vest-by-vest-4':
        option_name = 'Afhent hos VEST by VEST';
        suffix = '_l';
      break;
    }

    var no_shipping_text = document.getElementById("no_shipping").innerHTML;
    var no_shipping = (no_shipping_text == "true");
    
    if (no_shipping) {
      suffix = "_no_shipping";
      }

    $('#delivery-option-name').attr('value', option_name);
    update_shipping_product_cart(suffix);
  });


  function UpdateCartAndTotal() {
    var getTemplate = function (template) {
      return $($('[data-value=' + template + ']').html());
    };

    jQuery.getJSON('/cart.js', function (cart, textStatus) {
  
      var $table = getTemplate('cart-page-table');
      var $tbody = $table.find('tbody');
      var $row = getTemplate('cart-page-table-item');
      var $total = getTemplate('cart-page-total');
      var shipping_total = '(Vælg levering først)';


      $tbody.empty();

      var i;
      for (i=0; cart['items'][i]; i++){
        var item = cart.items[i];
        var $item = $row.clone();

        var price = price_look_convert(cart['items'][i]['price']);
        var total = price_look_convert(cart['items'][i]['line_price']);
      
        $item.find('.nomob > a').attr('href', item.url)
                                .attr('title', item.title);

        $item.find('.nomob img').attr('src', item.image)
                                .attr('width', 100);

        $item.find('.nomob p a').attr('href', item.url)
                                .html(item.title);

        $item.find('.item-price').html( total);

        $item.find('.requires-shipping').html(item.requires_shipping?"true":"false");

        if (item.title.indexOf('Fragt') != -1) {
          shipping_total = total;

          $item.addClass('shipping-line');
        }

        $item.find('td [data-type=item-price]').html(price);
        $item.find('input').attr('name', "updates[" + item.id + "]")
                           .attr('id', "updates_" + item.id)
                           .attr('value', item.quantity);

        $item.find('.trash a').attr('onclick', 'remove_item(' + item.id + '); return false;');
        $item.find('.trash img').attr('src', "\/\/test-vestbyvest.myshopify.com\/cdn\/shop\/t\/2\/assets\/cross.png?v=80293428419852293761414016860");

        $tbody.append($item);
      }

      var total_price = cart.total_price;
    
      var no_shipping_text = document.getElementById("no_shipping").innerHTML;            
      
      var no_shipping = (no_shipping_text == "true") || (sentinel.shipping == "afhent-hos-vest-by-vest-4");
      if (total_price >= 54800)
        no_shipping = true;
      if (no_shipping) {
        shipping_total = "0,00";
      }
            
      $total.find('#cart-shipping-total').html(shipping_total.toString());
      $total.find('h3').html('Subtotal <span>'+price_look_convert(total_price)+"</span>");

      $('[data-type=cart-container] table').replaceWith($table);
      $('[data-type=cart-container] #basket-right').replaceWith($total);
    
      $("#total_price").html(total_price);
 
      
      $("#cartform .quantity").change(function() {sentinel.updating_quantity = true; $("#cartform").submit(); sentinel.updating_quantity= false;});
    
    });
  }
  
  Shopify.onCartUpdate = function(cart, form) {
  if (!mod_carts)
    UpdateCartAndTotal();
  };
    
  check_is_only_shipping_item();  //to check either shipping product is only left in cart

  function clear_all_options() {
      $('.pakke-shop-address div').each(function(){
        $(this).hide();
      });
      $('#pakke-shop option:first').attr('selected' , 'selected');
      $('.sub-div .work-shipping-div select#work-address-country option:first').attr('selected', true);
      $('select#local-shop option:first').attr('selected', true);
      $('.pakke-shipping-div .pakke_shop_name_label').val('');
      $('.work-shipping #work-address-name').val('');
      $('.work-shipping #work-address-address').val('');
      $('.work-shipping #work-address-city').val('');
      $('.work-shipping #work-address-zip-code').val('');
  }

  function set_work_address_to_match_country() {
    var value = $('select#country').children('option:selected').val();
    $('.sub-div .work-shipping-div select#work-address-country option').each(function(){
      if ($(this).val() == value){
        $(this).attr('selected', true);
      } else {
        $(this).attr('selected', false);
      }
    });
  }

  function update_shipping_product_cart(suffix){
    var country = $('select#country option:selected').text();
    if (country == ''){
      country = 'Denmark';
    }
    country = country + suffix;

    var amount = rates[country];
    
    var total_price = parseFloat($("#total_price").html());
    
    // free shipping
    
    if (total_price >= 54800)
      amount = 0;

    if (amount == 0){
      Shopify.removeItem(shipping_prod_id);
      
      if (sentinel.shipping_selected) 
        sentinel.shipping = sentinel.shipping_selected;
    }
    else{
      var amt_str = amount;
      shiping_in_cart(amt_str);
    }
  }

  function shiping_in_cart(amt_str){
  
  mod_carts = true;
  Shopify.removeItem(shipping_prod_id, function() {

     Shopify.addItem(shipping_prod_id, amt_str, function(line) {
        if (sentinel.shipping_selected) {
         sentinel.shipping = sentinel.shipping_selected;       
         }
         
        UpdateCartAndTotal();
      }    
    );
    }
  );
  mod_carts = false;
    
  }

  function call_ajax_set_country(){

    $.getJSON( "http://freegeoip.net/json/", function(data){

      var ip = data.ip;
        jQuery.support.cors = true;

      jQuery.ajax({
        url:"http://geoip.maxmind.com/f?l=oJG5W2SRvlS8&i="+ip,
//        url:"http://geoip.maxmind.com/f?l=oJG5W2SRvlS8&i=217.116.227.8",

        success:function(result){


          var response_data = result.split(',');
          var country_short = response_data[0];
          var city_name = response_data[2];
          if (country_short == 'DK'){

            //get zipcode of cityname
            var zipcodePakke = denmark_city_zipcodes[city_name];

            if (zipcodePakke){
              jQuery.ajax({
                url: "http://morfars-metafields.herokuapp.com/pakke_in_zip/"+zipcodePakke,

                success: function (response) {


                  var parse_obj = jQuery.parseJSON(response);
                  var drop_down_pakke_html = '<option value="" id="1"></option>';
                  var pakke_data = '<div style="" class="1">  </div>';

                  if (!parse_obj){
                    parse_obj = response;
                  }

                  if (parse_obj.length){
                    for(var i=0; i<parse_obj.length; i++){
                        var j = i+851;
                        drop_down_pakke_html += '<option value="'+parse_obj[i]['number']+'" id="'+parse_obj[i]['number'] +'">'+parse_obj[i]['zip_code']+' '+parse_obj[i]['company_name']+'</option>';
                        pakke_data += '<div style="display:none" class="'+j+'">'+parse_obj[i]['company_name']+'<br>'+parse_obj[i]['streetname']+'<br><div class="shop_no" style="display: none;">'+parse_obj[i]['number']+'</div>'+parse_obj[i]['zip_code']+', '+parse_obj[i]['city_name']+'</div>';
                      }

                      $('.pakke-shipping-div select#pakke-shop option:first').text('-----------------------------------------------');
                      $('.pakke-shipping-div select#pakke-shop option:first').attr('disabled', 'disabled');

                      var old_html_drop = $('.pakke-shipping-div select#pakke-shop').html();
                      var old_html_data = $('.pakke-shipping-div .pakke-shop-address').html();

                      $('.pakke-shipping-div select#pakke-shop').html(drop_down_pakke_html+old_html_drop);
                      $('.pakke-shipping-div .pakke-shop-address').html(old_html_data+pakke_data);
                    }
                }
              });
            }
          }
          if (country_short == ''){
            country_short = 'DK';
          }

          var country_name = short_names_country[country_short];
          if(!country_name){ // cannot find a list of supported countries, use denmark
            country_name = 'Denmark';
          }

          $('.country-shipping-form select#country option').each(function(){
            $(this).removeAttr('selected');
          });


          if ( $('.country-shipping-form select#country').val() != country_short){
            sentinel.shipping = ""; // force shipping method check at checkout time
            sentinel.shipping_selected = "";            
            }

          if (country_name == 'Denmark'){
            $('.country-shipping-form select#country option:first').attr('selected' , 'selected');
          }
          else{
             $('.country-shipping-form select#country option').each(function(){
              if ($(this).text() == country_name){
                $(this).attr('selected' , 'selected');
              }
            });
            $('.country-shipping-form select#country').val(country_short);
          }

          //weird bug in firefox where the selected value does not refresh on screen after setting it here.
          select_text = $('select#country').html();

          $('select#country').html(select_text);


          no_shipping = $("#no_shipping").html() == "true";

          // if not already hidden by no shipping
          if (no_shipping) {
            sentinel.shipping = "hjem-til-3";
            sentinel.shipping_selected = "hjem-til-3";            
          }
          else{
            if (($('select#country option:selected').val() == '') || ($('select#country option:selected').val() == 'DK')){
              $('.dk-only').show();
            }else{
              $('.dk-only').hide();
            }
          }

          $('.sub-div .work-shipping-div select#work-address-country option:first').attr('selected', true);
          $('select#local-shop option:first').attr('selected', true);


          var data = result.split(',');
          var city_name = data[2];

        }
      });
    });


  }

  $('.shop-shipping-div #local-shop').change(function(){

    var id = $(this).children(":selected").attr('id')

    $('.local-shop-address div').each(function(){
      $(this).hide();
    });

    $('.local-shop-address').find('#'+id).show();

  });


  check_if_shipping_needed();
});   /***document ready end****/



function check_if_shipping_needed() {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {

  var shipping = false;
  var total_amt = 0.0;
    
   for (var i=0; cart['items'][i]; i++){
     if (cart['items'][i]['requires_shipping'] == true){
       shipping = true;
     }
     total_amt += cart['items'][i]['line_price'];
   }
    

   if (!shipping && cart['items'].length > 0) {
     $("#no_shipping").html("true");

     $(".shipping-category-block").hide();
     $(".step2").hide();
     $(".country-shipping-form").hide();
     

     $("#checkout-controls-container").css("position", "relative");
     $(".checkout-controls").css("margin-left", "90px");
     $("#checkout-controls-container").removeClass("five");

     $(".shipping-form").parent().removeClass();

     //hide shipping options
     $("#hjem-til-3.shipping-rates-div").trigger("click");

   }
   else {
    $("#no_shipping").html("false");
   }
   var shipping_prod_id = $('.shipping_prod_variant_id').text();

   Shopify.removeItem(shipping_prod_id);
/*
   if ((screen.width>=480)) {

     if (shipping){
       $(".shipping-category-block").click(function() {
         // .position() uses position relative to the offset parent, 
         // so it supports position: relative parent elements
         var pos = $(this).position();

         // .outerWidth() takes into account border and padding.
         var width = $(this).outerWidth();

         //show the menu directly over the placeholder
         $("#checkout-controls-container").css({
             position: "absolute",
             top: pos.top + "px",
             left: (pos.left + width - 4) + "px"
         });
   	});
     }
     else {
       //show the menu directly over the placeholder
       $("#checkout-controls-container").css({
           position: "relative",
           top: "0",
           width: "400px",
           left: "0"
       });
     }   
   }
*/
    
   return;
   });
   
   
}   /***document ready end****/


/*********** Convert 100 to 1,00 **************/
function price_look_convert(price){
  if (price === 0) return 0;

  price = ''+price;
  var length = price.length;
  var str_price = price.substring(0, length-2);
  str_price += ',';
  str_price += price.substring(length-2, length);
  return addThousandSeperator(str_price);  
}

function addThousandSeperator(nStr)
{
    var sep = '.';
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + sep + '$2');
    }
    return x1 + x2;
}


function check_is_only_shipping_item(){
  jQuery.getJSON('/cart.js', function (cart, textStatus) {

  for (var i=0; cart['items'][i]; i++){
    if (cart['items'][i]['title'].indexOf('Fragt') == -1){
      return;
    }
  }
  var shipping_prod_id = $('.shipping_prod_variant_id').text();

  Shopify.removeItem(shipping_prod_id);
  return;
  });
}